module.exports = __webpack_public_path__ + "static/media/stripe-payments.32f26184.svg";